module.exports = __webpack_public_path__ + "static/media/stage3.18c53f1b.svg";